import script from "./LaudoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LaudoModal.vue?vue&type=script&setup=true&lang=js"

import "./LaudoModal.vue?vue&type=style&index=0&id=a94fc89c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a94fc89c"]])

export default __exports__